module.exports = __webpack_public_path__ + "icon-framework-java.5K4U6wTg.svg";